import * as CONSTANTS from "../../utils/routing/constants";

import { reset_right_rail } from "../../reducers/RightRail/reducer";
import { receive_content } from "../../reducers/Content/reducer";
import { fetchLandingPageData } from "../Landing/initData";
import { fetchDetailPageData } from "../Detail/initData";
import { fetchAuthorProfilePageData } from "../AuthorProfilePage/initData";
import { fetchFlexibleLandingPageData } from "../FlexibleLandingPage/initData";
import { fetchLiveStoryPageData } from "../LiveStory/initData";
import { fetch_tracking } from "../../actions/Tracking/dispatchers";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";
import { titleUpdate } from "../../actions/App/dispatchers";

export const fetchPreviewPageData = (path, params, query) => (dispatch) => {
    if (query.type === "contentpackage" || query.type === "landing") {
        return dispatch(fetchLandingPageData(path, params));
    } else if (query.type === "flp") {
        return dispatch(fetchFlexibleLandingPageData(path));
    } else if (query.type === "authorbio") {
        return dispatch(fetchAuthorProfilePageData(path, params));
    } else if (query.type === "livestory") {
        return dispatch(fetchLiveStoryPageData(path, params));
    } else {
        return dispatch(fetchDetailPageData(path, params));
    }
};

export const fetchBlankPageData = (path, params) => (dispatch) => {
    let { section } = params;
    dispatch(reset_app_state(path));
    dispatch(reset_right_rail());

    if (path === "/search") {
        dispatch(titleUpdate("Search CBC.ca"));
    }

    dispatch(fetch_tracking({}, false));

    const receiveContentArgs = {
        contentList: [],
        pageValue: 1,
        section,
        contentType: "",
        timestamp: null,
        status: CONSTANTS.STATUS_CODE_SUCCESS,
    };
    dispatch(receive_content(receiveContentArgs));

    return Promise.resolve();
};

export const fetchFinancePageData = (path, params) => (dispatch) => {
    return dispatch(fetchBlankPageData("/news/business", params));
};
